import React from "react";
import { BsArrowLeft } from "react-icons/bs";
import { FaHome } from "react-icons/fa";
import { Link } from "react-router-dom";

const Error = () => {
  return (

<div className="min-h-screen  flex items-center justify-center px-6 ">
      <div className="max-w-2xl mx-auto text-center">
        {/* 404 */}
        <h1 className="text-[120px] md:text-[180px] font-extrabold leading-none text-[#24316B] opacity-90">
          404
        </h1>

        {/* Title */}
        <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
          Page Not Found
        </h2>

        {/* Description */}
        <p className="text-gray-600 text-lg mb-8 max-w-lg mx-auto">
          Sorry, the page you're looking for doesn't exist or may have been
          moved. But our mission to support children
      and communities continues.
        </p>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 bg-[#24316B] hover:bg-white hover:text-[#24316B] text-white px-6 py-3 rounded-xl font-semibold transition-all duration-300 shadow-md"
          >
            <FaHome size={18} />
            Back to Home
          </Link>

          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center justify-center gap-2 border-2 border-orange-500 text-orange-500 hover:bg-orange-500 hover:text-white px-6 py-3 rounded-xl font-semibold transition-all duration-300"
          >
            <BsArrowLeft size={18} />
            Go Back
          </button>
        </div>

        {/* Decorative Card */}
        <div className="mt-12 bg-orange-50 border border-orange-100 rounded-2xl p-6">
          <p className="text-orange-500 font-medium">
         Together We can bring education, food, and hope to every child.
          </p>
        </div>
      </div>
    </div>


  );
};

export default Error;
